import React, { useEffect, useState } from 'react'
import RegisterViewV3 from './RegisterViewV3';
import { STEPS_REGISTER, verify_id_number } from '../../utils/util';
import { useTranslation } from 'react-i18next';
import { getAddressHome, getPackageInfo, isVumaReachPackage } from '../../utils/commons';
import { lab4services } from '../../services/wsclients/lab4services';
import CustomLoading from '../../components/CustomLoading';
import { cached } from '../../utils/cache';
import wsclients from '../../services/wsclients';
import CustomAlert from '../../components/CustomAlert';

export default function RegisterControllerV3(props) {
    const { t } = useTranslation();
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [validations, setValidations] = useState({
        email: undefined,
        password: undefined,
    });
    const [showLoadingEmail, onShowLoadingEmail] = useState(false);
    const [step, setStep] = useState(props.tab ? props.tab : 'contact_info');
    const [registerInfo, setRegisterInfo] = useState(cached.getContactInfo() ? cached.getContactInfo() : null);

    const package_info = getPackageInfo() ? getPackageInfo() : null;
    const address = getAddressHome() ? getAddressHome() : null;

    useEffect(() => {
        if (step === 'address_info') {
            props.stepsControl.goToStepByName(STEPS_REGISTER.rica_verification)
        }
    }, [step]);

    const onHandleBlur = (value, target) => {
        let validPhone = false;
        let validPassword = false;
        let validIdNumber = false;
        let validConfirmPassword = false;
        if (target === 'phone') {
            if (!value || isNaN(value)) validPhone = true;
            else if (value && value.length !== 10) {
                validPhone = true;
            } else {
                if (value) {
                    let startItem = value.substr(0, 1);
                    if (startItem !== '0') {
                        validPhone = true;
                    }
                }
            }
            setValidations(prevState => ({
                ...prevState,
                phone: validPhone,
            }));
            return validPhone;
        }
        if (target === 'password') {
            if (!value) {
                validPassword = true;
            } else if (value && value.length < 8) {
                validPassword = true;
            }
            setValidations(prevState => ({
                ...prevState,
                password: validPassword,
            }));
            return validPassword;
        }
        if (target === 'id_number') {
            if (value && value.length !== 13) {
                validIdNumber = true;
            }
            else validIdNumber = verify_id_number(value) ? false : true;
            console.log("onvalidate id number ===", validIdNumber);
            setValidations(prevState => ({
                ...prevState,
                id_number: validIdNumber,
            }));
            return validIdNumber;
        }
        if (target === 'confirm_password') {
            if (!value) validConfirmPassword = true;
            else if (value && value.length < 8) {
                validConfirmPassword = true;
            }
            setValidations(prevState => ({
                ...prevState,
                confirm_password: validConfirmPassword,
            }));
            return validConfirmPassword;
        }
        return false;
    }

    const checkValidateAddress = async (values) => {        
        const { street_number, street_name, town_city, postal_code, state_province_county, apartment_name, apartment_number } = values;
        onShowLoading(true);
        try {
            let isCheckLocation = false;
            if (address && (address.tactical || address.pre_order_allowed)) {
                isCheckLocation = true;
            } else {
                isCheckLocation = await onCheckLocation(address.premise_ref_isp, address.openserve_ref_isp, address.metrofibre_ref_isp);
            }
            // isCheckLocation = true;//FAKE
            if (!isCheckLocation) {
                onShowMessage({
                    show: true,
                    content: t('address_used')
                });
                return false;
            }
            let addressHome = {
                street_number: street_number,
                street_name: street_name,
                town_city: town_city,
                postal_code: postal_code,
                apartment_name: apartment_name,
                apartment_number: apartment_number,
                state_province_county: state_province_county,
                building: values.building ? values.building : null,
                mdu_name: values.mdu_name ? values.mdu_name : null,
                mdu_unitno: values.mdu_unitno ? values.mdu_unitno : null
            }
            cached.setAddressInfo(addressHome);
            if (isVumaReachPackage(package_info.product_type)) {
                props.stepsControl.goToStepByName(STEPS_REGISTER.payment);
            } else {
                props.stepsControl.goToStepByName(STEPS_REGISTER.billing_date);
            }
            onShowLoading(false);
        }
        catch (error) {
            onShowLoading(false);
            console.log("register EXCEPPPPTIONNNN", error);
            onShowMessage({ show: true, content: t('EXCEPTION') })
        }
        onShowLoading(false);
    }

    const checkValidateContactInfo = async (values) => {
        const { first_name, last_name, email_address, mobile_number, password, confirm_password, id_number, passport_number, referral_code } = values;
        if (id_number || passport_number) {
            onShowLoading(true)
            let check_email = await onCheckEmail(email_address)
            onShowLoading(false)
            let validEmail = onHandleBlur(email_address, 'email');
            let validPassword = onHandleBlur(password, 'password');
            let validIdNumber = passport_number ? false : onHandleBlur(id_number, 'id_number');
            let validConfirmPassword = onHandleBlur(confirm_password, 'confirm_password');
            if (!validEmail && !validPassword && !validIdNumber && !validConfirmPassword) {
                let contact_info = {
                    first_name: first_name,
                    last_name: last_name,
                    email: email_address,
                    password: password,
                    phone_number: mobile_number,
                    id_number: id_number,
                    passport_number: passport_number,
                    // state_province_county: state_province_county,
                    referral_code: referral_code
                }
                cached.setContactInfo(contact_info);
                if (!check_email) {
                    setStep('address_info');
                }
            }
            else {
                if (validIdNumber) {
                    onShowMessage({ show: true, content: t('INVALID_ID') })
                }
            }
        } else {
            onShowMessage({ show: true, content: t('MUST_INPUT_ID_OR_PASSPORT') })
        }
    }

    const onCheckLocation = async (location_id, openserve_ref_isp, metrofibre_ref_isp) => {
        let isAllowLocation = false;
        try {
            let queryParams = {
                locationId: location_id,
                openserve_ref_isp: openserve_ref_isp,
                metrofibre_ref_isp: metrofibre_ref_isp,
            }
            if (package_info && package_info.product_type == 'octotel') {
                queryParams = {
                    uuid: address.premisesid,
                    lat: address.latitude,
                    lng: address.longitude,
                }
            }
            let result = await lab4services.checkLocationAvaibleOrderV3(queryParams);
            console.log("AAAA onCheckLocation result: ", result);
            if (result.code != 'OK') return false;

            const showMessageHandle = (msg) => {
                onShowMessage({
                    show: true,
                    content: msg || t('address_used'),
                });
            }
            let product_type = package_info?.product_type || null;
            switch (product_type) {
                case 'openserve': 
                    if (result?.data?.is_availabe_create_openserve_order) {
                        isAllowLocation = onCheckProductsOpenserve(result.data.openserve_services);
                    } else if (!result?.data?.is_availabe_create_openserve_order) {
                        showMessageHandle(result?.data?.descriptions);
                        isAllowLocation = false;
                    }
                    break;
                case 'octotel': 
                    if (result?.data?.octotel_services?.length > 0) {
                        isAllowLocation = result.data.octotel_services.some(service => package_info.code.includes(service.productCode) );
                    } else {
                        showMessageHandle(result?.data?.descriptions);
                    }
                    break;
                case 'metrofibre': 
                    if (result?.data?.is_available_create_order_metrofibre) {
                        isAllowLocation = true;
                    } else {
                        isAllowLocation = false;
                    }
                    break;
                default:
                    if (result?.data?.is_available_create_order) {
                        isAllowLocation = true;
                    } else {
                        showMessageHandle(result?.data?.descriptions);
                        isAllowLocation = false;
                    }
                    break;
            }            
        } catch (ex) {
            console.log("AAAA onCheckLocation exception: ", ex);
        }
        return isAllowLocation;
    }

    const onCheckProductsOpenserve = (openserveServices) => {
        let isCheck = false;
        try {
            if (openserveServices && openserveServices.length > 0 && package_info && package_info.sku) {
                for (let i = 0; i < openserveServices.length; i++) {
                    const item = openserveServices[i];
                    if (package_info.sku.includes(item.ProductCode + '-')) {
                        isCheck = true;
                        break;
                    }
                }
            }
        } catch (error) {
            console.log("AAAA onCheckProductsOpenserve error: ", error);
        }
        console.log("AAAA onCheckProductsOpenserve isCheck: ", isCheck)
        return isCheck;
    }

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }

    const onCheckEmail = async (email) => {
        try {
            onShowLoadingEmail(true);
            let email_value = null
            if (email && email.target && email.target.value) {
                email_value = email.target.value
            } else {
                email_value = email
            }
            let result = await wsclients.lab4services.onCheckEmailAddress(email_value);
            console.log("onCheckEmailAddress result===", result);
            onShowLoadingEmail(false);
            if (result.code === 'OK') {
                if (result.data.result === 'VALID') {
                    setValidations({
                        ...validations,
                        email: false,
                    });
                    return undefined;
                }
            }
            setValidations({
                ...validations,
                email: true,
            })
            return t('Please enter a valid e-mail address');
        }
        catch (ex) {
            console.log("onCheckEmailAddress exception===", ex);
        }
    }

    return (
        <div>
            {showLoading && <CustomLoading open={showLoading} />}
            <RegisterViewV3
                {...props}
                validations={validations}
                showLoadingEmail={showLoadingEmail}
                address={address}
                registerInfo={registerInfo}
                addressCached={cached.getAddressInfo()}
                step={step}
                onCheckEmail={onCheckEmail}
                setStep={setStep}
                // onSubmit={onSubmit}
                checkValidateContactInfo={checkValidateContactInfo}
                checkValidateAddress={checkValidateAddress}
                onHandleBlur={onHandleBlur}
            />
            {message && message.show && <CustomAlert
                open={message.show}
                message={message.content ? message.content : (message.message ? message.message : 'Unknown error!')}
                showButtonClose={true}
                isConfirm={message.isConfirm ? message.isConfirm : null}
                confirmAction={message.confirmAction ? message.confirmAction : null}
                onClose={message.action ? message.action : () => onShowMessage({})}
                okTitle={message.okTitle}
                cancelTitle={message.cancelTitle}
                title={message.title}
                // color={palette.primary.main}
            />}
        </div>
    );
}